import React from "react";
import { useIntl } from "react-intl";
import { Tag } from "antd";

export default function CleanStatus({ cleaned }) {
  const intl = useIntl();
  return (
    <Tag color={cleaned ? "green" : "red"} style={{ minWidth: 88, marginRight: 0, textAlign: "center", textTransform: "uppercase" }}>
      {intl.formatMessage({ id: cleaned ? "cleaned" : "dirty" })}
    </Tag>
  );
}
